import IS_EFAS from "../sitebase/Environment";

export default function setTitle(title: string) {
    if (import.meta.env.PROD && Object.prototype.hasOwnProperty.call(window, "_paq")) {
        (window as unknown as { _paq: { push: (args: string[]) => void } })._paq.push(['trackEvent', 'Navigate', 'To', window.location.pathname]);
    }

    document.title = `${title} | Copernicus EMS - ${IS_EFAS ? "European Flood Awareness System" : "Global Flood Awareness System"}`;
}